import { render, staticRenderFns } from "./AddAdmins.vue?vue&type=template&id=a3ea9e5e&scoped=true"
import script from "./AddAdmins.vue?vue&type=script&lang=js"
export * from "./AddAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ea9e5e",
  null
  
)

export default component.exports